// 用于本地存储记录key
const storageName = {
    TokenName: 'ailifeusWebsiteToken',
}
export { storageName }





// WEBPACK FOOTER //
// ./src/utils/storageName.js